@if (consentService.bannerOpen()) {
  <div class="fixed bottom-4 right-4 z-40 flex justify-end px-4 sm:px-0" role="dialog" aria-modal="false" [attr.aria-label]="'cookieConsent.title' | translate">
    <div class="w-full max-w-[320px] bg-white rounded-lg border border-border shadow-lg p-4">
      <div class="flex flex-col gap-3">
        <div>
          <h2 class="text-[13px] font-semibold text-ink leading-[1.3] mb-1">{{ 'cookieConsent.title' | translate }}</h2>
          <p class="text-xs text-muted leading-[1.5]">
            {{ 'cookieConsent.message' | translate }}
            <a routerLink="/privacidade" class="text-primary-500 font-semibold hover:text-primary-600 transition-colors duration-[160ms]">{{ 'cookieConsent.privacyLink' | translate }}</a>
          </p>
        </div>

        @if (customizing()) {
          <div class="flex flex-col gap-3 border-t border-border pt-3">
            <div class="flex items-start justify-between gap-3">
              <div class="flex flex-col gap-0.5">
                <span class="text-xs font-semibold text-ink leading-[1.4]">{{ 'cookieConsent.essentialTitle' | translate }}</span>
                <span class="text-[11px] text-muted leading-[1.4]">{{ 'cookieConsent.essentialDesc' | translate }}</span>
              </div>
              <wy-toggle [valor]="true" [disabled]="true" [ariaLabel]="'cookieConsent.essentialTitle' | translate" />
            </div>
            <div class="flex items-start justify-between gap-3">
              <div class="flex flex-col gap-0.5">
                <span class="text-xs font-semibold text-ink leading-[1.4]">{{ 'cookieConsent.analyticsTitle' | translate }}</span>
                <span class="text-[11px] text-muted leading-[1.4]">{{ 'cookieConsent.analyticsDesc' | translate }}</span>
              </div>
              <wy-toggle [valor]="analyticsDraft()" (alterado)="analyticsDraft.set($event)" [ariaLabel]="'cookieConsent.analyticsTitle' | translate" />
            </div>
            <div class="flex items-start justify-between gap-3">
              <div class="flex flex-col gap-0.5">
                <span class="text-xs font-semibold text-ink leading-[1.4]">{{ 'cookieConsent.adsTitle' | translate }}</span>
                <span class="text-[11px] text-muted leading-[1.4]">{{ 'cookieConsent.adsDesc' | translate }}</span>
              </div>
              <wy-toggle [valor]="adsDraft()" (alterado)="adsDraft.set($event)" [ariaLabel]="'cookieConsent.adsTitle' | translate" />
            </div>
          </div>
        }

        <div class="flex flex-col gap-1.5">
          @if (customizing()) {
            <button
              type="button"
              (click)="saveCustom()"
              class="w-full min-h-8 px-3 py-1.5 rounded-md bg-primary-500 hover:bg-primary-600 active:bg-primary-700 text-white font-semibold text-xs transition-colors duration-[160ms] focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-primary-500/30"
            >
              {{ 'cookieConsent.save' | translate }}
            </button>
            <button
              type="button"
              (click)="customizing.set(false)"
              class="w-full min-h-8 px-3 py-1.5 rounded-md text-xs font-semibold text-muted hover:text-ink hover:bg-surface transition-colors duration-[160ms] focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-primary-500/30"
            >
              {{ 'cookieConsent.back' | translate }}
            </button>
          } @else {
            <button
              type="button"
              (click)="acceptAll()"
              class="w-full min-h-8 px-3 py-1.5 rounded-md bg-primary-500 hover:bg-primary-600 active:bg-primary-700 text-white font-semibold text-xs transition-colors duration-[160ms] focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-primary-500/30"
            >
              {{ 'cookieConsent.acceptAll' | translate }}
            </button>
            <div class="flex items-stretch gap-1.5">
              <button
                type="button"
                (click)="rejectNonEssential()"
                class="flex-1 min-w-0 min-h-8 px-2 py-1.5 rounded-md text-xs font-semibold text-muted hover:text-ink hover:bg-surface transition-colors duration-[160ms] focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-primary-500/30"
              >
                {{ 'cookieConsent.rejectNonEssential' | translate }}
              </button>
              <button
                type="button"
                (click)="startCustomize()"
                class="flex-1 min-w-0 min-h-8 px-2 py-1.5 rounded-md text-xs font-semibold text-muted hover:text-ink hover:bg-surface transition-colors duration-[160ms] focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-primary-500/30"
              >
                {{ 'cookieConsent.customize' | translate }}
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
